/**
 * Firebase Service — TC Steward Admin
 * Same project as customer app (wpxg-33e67).
 */
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { initializeFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: 'AIzaSyCX5lPeACYg6JXFv6m2tEIaEyShO5p45Qc',
  authDomain: 'wpxg-33e67.firebaseapp.com',
  projectId: 'wpxg-33e67',
  storageBucket: 'wpxg-33e67.appspot.com',
  messagingSenderId: '824752033941',
  appId: '1:824752033941:web:77c75433f4e2d7cd280b9c',
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

/* Force long-polling rather than letting Firestore probe for it.

   Firestore tries a streaming (WebSocket) transport first. On networks that
   silently drop it — some corporate/guest Wi-Fi, some proxies — the probe runs
   to a ~30 second timeout before falling back, and every query issued in that
   window returns at once, long after it should have. We measured exactly that
   in the admin dashboard: queries matching ZERO documents taking 29 seconds.

   initializeFirestore (rather than getFirestore) is required because these
   settings must be supplied when the instance is created. */
const db = initializeFirestore(app, {
  experimentalForceLongPolling: true,
});
const functions = getFunctions(app, 'us-central1');

export { app, auth, db, functions };
